import { maybe } from "kanopi-components/utils/functional";
import * as React from "react";

import { Checkbox } from "../Checkbox";
import { BaseOption } from "./BaseOption";

const ToggleOption: React.FC<TSelectable> = (props) => {
  const { value, selected, onChange, onBlur, ...restProps } = props;

  return (
    <BaseOption
      {...props}
      control={
        <Checkbox
          checkmarkType={Checkbox.STYLE_TYPE.toggle_round}
          value={selected}
          onChange={() => onChange(value)}
          onBlur={(...args) => {
            // onBlur and value are changed in the same event loop. This will cause onBluer
            // to be called with the old value. This is a workaround to make sure onBlur is
            // called with the new value.
            setTimeout(() => {
              maybe(onBlur)(...args);
            }, 100);
          }}
        />
      }
    />
  );
};

export { ToggleOption };
